export type Information = {
  title: string;
  description: string;
};

export const informations: Information[] = [
  { title: '培訓時間', description: '2026 年 8 月 ~ 2027 年 8 月' },
  { title: '報名資格', description: '升大二至升碩一之全台大專院校學生，不限科系' },
  { title: '培訓地點', description: '市政府站附近之租借場地' },
  { title: '報名時間', description: '2026/05/25 00:00   至   2026/07/10 23:59' },
  { title: '培訓費用', description: '一年 3000 元' },
  { title: '甄選流程', description: '資料初審 → 公布面試名單（7/19） → 團體面試（8/1、8/2） → 公布錄取（8/12）' },
];
